<template>
  <h3>{{ $t('reportsPage') }}</h3>
</template>
<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Reports',
  });
</script>


